<div class="dropdown" ngbDropdown placement="bottom-end" container="body" display="dynamic">
  <button class="btn btn-link position-relative notification-bell-btn shadow-none" ngbDropdownToggle id="notificationDropdown" aria-label="Benachrichtigungen">
    <fa-icon [icon]="faBell" size="lg"></fa-icon>
    <span *ngIf="(unreadCount$ | async) > 0" class="position-absolute badge rounded-pill bg-danger">
      {{ unreadCount$ | async }}
      <span class="visually-hidden">ungelesene Benachrichtigungen</span>
    </span>
  </button>

  <div ngbDropdownMenu aria-labelledby="notificationDropdown" class="dropdown-menu notification-dropdown-menu shadow">
    <div class="dropdown-header d-flex justify-content-between align-items-center py-2">
      <span class="h6 mb-0">Benachrichtigungen</span>
      <button class="btn btn-sm btn-outline-primary" (click)="goToOverview()">Alle zeigen</button>
    </div>

    <div class="notification-list-scrollable">
      <div *ngIf="(unreadNotifications$ | async)?.length === 0" class="p-3 text-center text-muted">
        Keine neuen Benachrichtigungen
      </div>

      <div *ngFor="let notification of (unreadNotifications$ | async)"
           class="dropdown-item notification-item border-bottom py-2 px-3"
           (click)="handleNotificationClick(notification)">
        <div class="d-flex w-100 justify-content-between align-items-start">
          <div class="me-2 mt-1">
            <fa-icon [icon]="icons[notification.type] || icons['DEFAULT']"></fa-icon>
          </div>
          <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-center">
              <strong class="notification-title">{{ notification.title }}</strong>
              <small class="text-muted">{{ notification.createdAt | date:'HH:mm' }}</small>
            </div>
            <p class="notification-message mb-1 small text-truncate-2">{{ notification.message }}</p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-link btn-sm p-0 text-decoration-none" (click)="markAsRead(notification.id, $event)">
                Als gelesen markieren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-footer p-2 text-center border-top">
      <button class="btn btn-link btn-sm text-decoration-none w-100" (click)="goToOverview()">
        Zur Übersicht
      </button>
    </div>
  </div>
</div>
